import axiosInstance from "../../../../lib/axiosInstance";
import {
  SOURCES,
  mergeCatalog,
  normalizeDevice,
  normalizeFleetDrone,
  normalizePropulsionDrone,
} from "../droneCatalog";

// Fetching only. The normalising lives in ../droneCatalog.js so it can be
// tested without dragging axios through jest.

// The three endpoints are auth-gated, so their envelopes could not be read from
// outside. Accept a bare array or the usual wrappers rather than guessing one.
const rows = (data, ...keys) => {
  if (Array.isArray(data)) return data;
  for (const key of keys) if (Array.isArray(data?.[key])) return data[key];
  return [];
};

const fetchSource = async (path, keys, normalize) => {
  const response = await axiosInstance.get(path);
  return rows(response.data, ...keys).map(normalize);
};

/**
 * Every drone the caller can see, from all three registries.
 *
 * A registry that is unreachable or forbidden is reported, not thrown: two
 * working sources are a usable picker, and a hard failure here would take the
 * whole page down over a catalog the user may not even use.
 */
export const listDroneCatalog = async () => {
  const settled = await Promise.allSettled([
    fetchSource("/list_drones", ["drones", "items", "data"], normalizeFleetDrone),
    fetchSource("/devices", ["devices", "items", "data"], normalizeDevice),
    fetchSource("/propulsion/drones", ["drones", "items", "data"], normalizePropulsionDrone),
  ]);
  const unavailable = SOURCES.filter((_, i) => settled[i].status === "rejected");
  const entries = settled.flatMap((r) => (r.status === "fulfilled" ? r.value : []));
  return { entries: mergeCatalog(entries), unavailable };
};
